import './Services.css';
import Footer from '../../components/Footer/Footer';
import AboutIntermediation from '../../components/AboutIntermediation/AboutIntermediation';
import LoginIntermediary from '../../components/LoginIntermediary/LoginIntermediary';
import Intermediary from '../../components/Intermediary/Intermediary';
import React from 'react';

function Servicos() {
  return (
    <section className="flex flex-col absolute h-screen min-h-full w-full">
      <div id='login'>

        <div className="relative h-sm:hidden" >
          <div className="flex w-full z-10 pt-9 pb-9 absolute">
            <div className="mx-auto">
              <div className='mt-4'>
                <span className='text-3xl font-extrabold font-raleway text-white'>Você que atua no mercado <br /> de consórcio pode se tornar <br /> um de nossos intermediários </span>
              </div>
              <div className='mt-4'>
                <span className='text-base text-white font-bold'>Conheça nossos modelos<br /> de intermediação</span>
              </div>
            </div>
            <div className="mx-auto my-auto">
              <LoginIntermediary />
            </div>
          </div>
          <img src="services.png" alt="logo" className='z-0 top-0 left-0 h-80 w-full' />

        </div>
        <div className="relative h-sm:flex hidden">
          <div className="relative w-full z-10 pt-9 pb-9">
            <div className="mx-auto px-4">
              <div className='mt-4'>
                <span className='text-3xl font-extrabold font-raleway text-white'>Você que atua no mercado de <br /> consórcio pode se <br /> tornar um <br /> de nossos intermediários </span>
              </div>
              <div className='mt-4'>
                <span className='text-base text-white font-bold'>Conheça nossos modelos<br /> de intermediação</span>
              </div>
            </div>
          </div>
          <img src="services-mobile.png" alt="logo" className='absolute z-0 top-0 left-0 h-full w-full object-cover' />
        </div>
        <div className="hidden h-sm:block w-full bg-white px-4 py-8">
          <div className="mx-auto w-full max-w-md">
            <LoginIntermediary />
          </div>
        </div>
        <div className="flex w-full z-0 mt-20 h-sm:mt-0">
          <AboutIntermediation />
        </div>
        <div className="flex w-full z-0">
          <Footer />
        </div>

      </div>

      <React.Fragment>
        <Intermediary />
      </React.Fragment>
    </section>
  );
}

export default Servicos;
